var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNationalHealthServiceEnglandLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "National_Health_Service__England__logo",
    "data-name": "National_Health_Service_(England)_logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.827,
    height: 23,
    viewBox: "0 0 56.827 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24693",
    "data-name": "Rectangle 24693",
    width: 56.827,
    height: 23,
    fill: "#005eb8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52887",
    "data-name": "Group 52887",
    transform: "translate(1.604 1.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37027",
    "data-name": "Path 37027",
    d: "M14.413,14.475h6.181l3.789,12.84h.057l2.6-12.84h4.669L27.781,32.99H21.629L17.753,20.179H17.7L15.131,32.99H10.463Z",
    transform: "translate(-10.463 -14.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37028",
    "data-name": "Path 37028",
    d: "M139.7,14.475h4.962l-1.46,7.084h5.865l1.46-7.084h4.962L151.646,32.99h-4.991l1.644-7.929h-5.836l-1.645,7.929h-4.956Z",
    transform: "translate(-116.635 -14.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37029",
    "data-name": "Path 37029",
    d: "M264.933,16.889a9.3,9.3,0,0,0-4.059-.851c-1.961,0-3.553.293-3.553,1.777,0,2.628,7.187,1.644,7.187,7.268,0,5.117-4.749,6.446-9.045,6.446a20.7,20.7,0,0,1-5.75-.954l1.15-3.766a9.64,9.64,0,0,0,4.56,1.064c1.616,0,3.95-.293,3.95-2.2,0-2.973-7.187-1.857-7.187-7.084,0-4.772,4.192-6.21,8.251-6.21a15.009,15.009,0,0,1,5.675.822Z",
    transform: "translate(-213.028 -12.375)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalHealthServiceEnglandLogo);
export default __webpack_public_path__ + "static/media/national_health_service_england_logo.80e8a4b32c22aaceabc0c3b01459ff11.svg";
export { ForwardRef as ReactComponent };